import axios from 'axios';

const SAVE_CONFLICT_CODES = ['version', 'name', 'closed', 'audience'] as const;

/** Why a save was refused, as the `code` of the backend's `409` body spells it. */
type SaveConflictCode = (typeof SAVE_CONFLICT_CODES)[number];

/** The save refusals that only need telling the reader, by code. */
export const CONFLICT_MESSAGE_KEYS = {
    closed: 'compensation.errors.envelopeClosed',
    audience: 'compensation.errors.audienceOutsideTeam',
} as const;

export const readConflictCode = (error: unknown): SaveConflictCode | null => {
    if (!axios.isAxiosError(error) || error.response?.status !== 409) {
        return null;
    }

    const code = (error.response.data as { code?: string } | undefined)?.code;
    return SAVE_CONFLICT_CODES.find((known) => known === code) ?? null;
};
